// extracted by mini-css-extract-plugin
export var controls = "carouselControlsD-module--controls--EF1SC";
export var icon = "carouselControlsD-module--icon---m15y";
export var inactive = "carouselControlsD-module--inactive--w791G";